import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IconLink } from "@tabler/icons-react";
import { isAdminUser } from "../state/useAppState";

export const useCreateApiKeyAction = () => {
    const [showCreateApiKeyModal, setShowCreateApiKeyModal] = useState(false);
    const navigate = useNavigate();
    const isAdmin = isAdminUser();

    const handleCloseCreateApiKeyModal = () => {
        setShowCreateApiKeyModal(false);
    };

    const handleOpenCreateApiKeyModal = () => {
        setShowCreateApiKeyModal(true);
    };

    const navigateToAdminPage = () => {
        navigate("/admin");
    };

    // Only show action if user is admin
    const redirectToAdminPage = isAdmin
        ? {
              name: "Admin",
              onClick: navigateToAdminPage,
              icon: <IconLink />,
              label: "Admin",
          }
        : null;

    return {
        showCreateApiKeyModal,
        handleCloseCreateApiKeyModal,
        handleOpenCreateApiKeyModal,
        redirectToAdminPage,
    };
};
